<template>
    <div
        v-show="visible"
        class="alert"
        :class="`alert-${variant}`"
        role="alert"
    >
        <button
            type="button"
            class="btn-close btn-close-sm"
            aria-label="Close"
            @click="visible = false"
            style="position: absolute; top: 12px; right: 10px; font-size: .8rem; height: 1rem"
        ></button>
        <span>{{ message }}</span>    </div>
</template>

<script setup>
import { ref } from 'vue'

const visible = ref(false)
const message = ref('')
const variant = ref('info')

const showAlert = (msg, type = 'info') => {
    message.value = msg
    variant.value = type
    visible.value = true
    setTimeout(() => {
        visible.value = false
    }, 5000)
}

// expose method to parent
defineExpose({ showAlert })
</script>

<style scoped>
.alert {
    position: fixed;
    top: 1.5em;
    left: 10em;
    right: 10em;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border-radius: 0.25rem;
    color: #404041;
    z-index: 9999;
}
</style>
